var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFengge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.5C8.5 2.84315 9.84315 1.5 11.5 1.5C13.1569 1.5 14.5 2.84315 14.5 4.5C14.5 6.15685 13.1569 7.5 11.5 7.5H8.5V4.5Z",
    fill: "#E75147",
    fillOpacity: 0.4,
    stroke: "#E75147"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12C8 13.6569 9.34315 15 11 15C12.6569 15 14 13.6569 14 12C14 10.3431 12.6569 9 11 9H8V12Z",
    fill: "#E75147"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5C7 3.34315 5.65685 2 4 2C2.34315 2 1 3.34315 1 5C1 6.65685 2.34315 8 4 8H7V5Z",
    fill: "#E75147"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 13.6569 5.65685 15 4 15C2.34315 15 1 13.6569 1 12C1 10.3431 2.34315 9 4 9H7V12Z",
    fill: "#E75147"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFengge);
export default __webpack_public_path__ + "static/media/fengge.241fcb2aaea5d36bb4fad61bb5c5c9f0.svg";
export { ForwardRef as ReactComponent };